import React from "react";
import { useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";

const TodayCollection = ({ selectedDate }) => {
  const [loans, setLoans] = useState([]);
  const [filteredLoans, setFilteredLoans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [collections, setCollections] = useState([]);
  const [dailyCollectionData, setDailyCollectionData] = useState([]);
  const [weeklyCollectionData, setWeeklyCollectionData] = useState([]);
  const normalizeName = (name) => name.trim().toLowerCase(); // To normalize names
  const [dailyCollectionByAgent, setDailyCollectionByAgent] = useState({});
  const [weeklyCollectionByAgent, setWeeklyCollectionByAgent] = useState({});
  const [dailyTotal, setDailyTotal] = useState(0);
  const [weeklyTotal, setWeeklyTotal] = useState(0);
  const baseURL = process.env.REACT_APP_BASE_URL;
  const [dailyCount, setDailyCount] = useState(0);
  const [weeklyCount, setWeeklyCount] = useState(0);

  const formatDate = (date) => {
    const [day, month, year] = date.split("-");
    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    const accessToken = sessionStorage.getItem("access_token");
    if (selectedDate !== "No date selected") {
      axios
        .get(`${baseURL}/getAllLoan`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        })
        .then((response) => setLoans(response.data))
        .catch((error) => console.error("Error fetching loans:", error))
        .finally(() => {
        setLoading(false);
      });
    }
  }, [selectedDate]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const accessToken = sessionStorage.getItem("access_token");
        const response = await axios.get(`${baseURL}/getAllCollection`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });
        setCollections(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
      finally{
        setLoading(false);
      }
    };
    fetchData();
  }, []); //fetching Data

  useEffect(() => {
    if (selectedDate && collections.length > 0) {
      const formattedDate = formatDate(selectedDate);

      // Filter collections by selected date
      const dailyCollections = collections.filter(
        (collection) =>
          collection.scheme_name?.toLowerCase() === "daily collection" &&
          collection.date === formattedDate
      );

      const weeklyCollections = collections.filter(
        (collection) =>
          collection.scheme_name?.toLowerCase() === "weekly collection" &&
          collection.date === formattedDate
      );

      // Aggregate data by agent for daily collections
      const dailyData = dailyCollections.reduce((acc, collection) => {
        const agentName = normalizeName(collection.name);
        if (!acc[agentName]) acc[agentName] = { totalAmount: 0, count: 0 };
        acc[agentName].totalAmount += parseFloat(collection.emi_amount) || 0;
        acc[agentName].count += 1;
        return acc;
      }, {});

      // Aggregate data by agent for weekly collections
      const weeklyData = weeklyCollections.reduce((acc, collection) => {
        const agentName = normalizeName(collection.name);
        if (!acc[agentName]) acc[agentName] = { totalAmount: 0, count: 0 };
        acc[agentName].totalAmount += parseFloat(collection.emi_amount) || 0;
        acc[agentName].count += 1;
        return acc;
      }, {});

      setDailyCollectionByAgent(dailyData);
      setWeeklyCollectionByAgent(weeklyData);

      setDailyTotal(
        Object.values(dailyData).reduce(
          (acc, item) => acc + item.totalAmount,
          0
        )
      );
      setWeeklyTotal(
        Object.values(weeklyData).reduce(
          (acc, item) => acc + item.totalAmount,
          0
        )
      );

      setDailyCount(
        Object.values(dailyData).reduce((acc, item) => acc + item.count, 0)
      );
      setWeeklyCount(
        Object.values(weeklyData).reduce((acc, item) => acc + item.count, 0)
      );
    }
  }, [selectedDate, collections]);

  const allAgents = new Set([
    ...Object.keys(dailyCollectionByAgent),
    ...Object.keys(weeklyCollectionByAgent),
  ]);

  useEffect(() => {
    console.log("Fetched collections:", collections);
    console.log("Daily Collection Data:", dailyCollectionData);
    console.log("Weekly Collection Data:", weeklyCollectionData);
  }, [collections, dailyCollectionData, weeklyCollectionData]);

  useEffect(() => {
    if (selectedDate && loans.length > 0) {
      const formattedSelectedDate = formatDate(selectedDate);
      const filtered = loans.filter(
        (loan) => loan.start_date === formattedSelectedDate
      );
      setFilteredLoans(filtered);
    }
  }, [selectedDate, loans]);

  const grandTotalAmount = dailyTotal + weeklyTotal;

  const formattedDate = formatDate(selectedDate);
  const dailyCollections = collections.filter(
    (collection) =>
      collection.scheme_name?.toLowerCase() === "daily collection" &&
      collection.date === formattedDate
  );
  const weeklyCollections = collections.filter(
    (collection) =>
      collection.scheme_name?.toLowerCase() === "weekly collection" &&
      collection.date === formattedDate
  );

  const aggregateCollections = (collections) => {
    const aggregated = collections.reduce((acc, collection) => {
      const { loan_id, tamilname, emi_amount } = collection;
      if (!acc[loan_id]) {
        acc[loan_id] = { ...collection, totalAmount: parseFloat(emi_amount) };
      } else {
        acc[loan_id].totalAmount += parseFloat(emi_amount);
      }
      return acc;
    }, {});
    return Object.values(aggregated);
  };

  // Aggregating daily and weekly collections
  const aggregatedDailyCollections = aggregateCollections(dailyCollections);
  const aggregatedWeeklyCollections = aggregateCollections(weeklyCollections);
if (loading) {
  return (
    <div className="flex justify-center items-center h-64">
      <p className="text-lg font-semibold text-gray-600">Loading…</p>
    </div>
  );
}
  
  return (
    
    <div className="p-5 bg-gray-50">
      
      <div className="bg-gray-200 p-3 rounded-lg flex flex-col md:flex-row justify-between items-start md:items-center space-y-2 md:space-y-0">
        <h1 className="text-lg font-semibold">Date : {selectedDate} </h1>
        <div className="text-right space-y-1">
          <div className="grid grid-cols-[auto_1fr] gap-x-4 text-right">
            <p className="font-bold">Daily :</p>
            <p className="tabular-nums">{dailyTotal.toFixed(2)}</p>

            <p className="font-bold">Weekly :</p>
            <p className="tabular-nums">{weeklyTotal.toFixed(2)}</p>

            <p className="font-bold">Total :</p>
            <p className="font-bold tabular-nums">
              {grandTotalAmount.toFixed(2)}
            </p>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-8 mt-5">
        <div className="p-5 bg-gray-50">
          <h2 className="text-lg font-bold mb-3 text-center">New Loans</h2>
          <div className="overflow-x-auto">
            <table className="min-w-full bg-white shadow-md rounded-lg overflow-hidden">
              <thead className="bg-gray-100">
                <tr>
                  <th className="py-2 px-4 text-left">Loan Id</th>
                  <th className="py-2 px-4 text-left">Customer Name</th>
                  <th className="py-2 px-4 text-left">Amount</th>
                </tr>
              </thead>

              <tbody>
                {filteredLoans.length > 0 ? (
                  filteredLoans.map((loan) => (
                    <tr key={loan.id}>
                      <td className="py-2 px-4">{loan.loan_id}</td>
                      <td className="py-2 px-4">{loan.tamilname}</td>
                      <td className="py-2 px-4">{loan.amount}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="text-center py-4 text-gray-500">
                      No data available for the selected date.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        <div className="p-5 bg-gray-50">
          <h2 className="text-lg font-bold mb-3 text-center">
            Agent Collections
          </h2>
          <div className="overflow-x-auto">
            <table className="min-w-full bg-white shadow-md rounded-lg overflow-hidden">
              <thead className="bg-gray-100">
                <tr>
                  <th className="py-2 px-4 text-left">Admin</th>
                  <th className="py-2 px-4 text-left">Daily Collection</th>
                  <th className="py-2 px-4 text-left">Weekly Collection</th>
                </tr>
              </thead>
              <tbody>
                {Array.from(allAgents).map((agentName) => {
                  const dailyData = dailyCollectionByAgent[agentName] || {
                    totalAmount: 0,
                    count: 0,
                  };
                  const weeklyData = weeklyCollectionByAgent[agentName] || {
                    totalAmount: 0,
                    count: 0,
                  };

                  return (
                    <tr key={agentName}>
                      <td className="py-2 px-4">{agentName}</td>
                      <td className="py-2 px-4">
                        {dailyData.totalAmount.toFixed(2)} ({dailyData.count})
                      </td>
                      <td className="py-2 px-4">
                        {weeklyData.totalAmount.toFixed(2)} ({weeklyData.count})
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>

        <div className="p-5 bg-gray-50">
          <h2 className="text-lg font-bold mb-3 text-center">
            Daily Collection
          </h2>
          <div className="overflow-x-auto">
            <table className="min-w-full bg-white shadow-md rounded-lg overflow-hidden">
              <thead className="bg-gray-100">
                <tr>
                  <th className="py-2 px-4 text-left">Loan Id</th>
                  <th className="py-2 px-4 text-left">Customer Name</th>
                  <th className="py-2 px-4 text-left">Amount</th>
                </tr>
              </thead>
              <tbody>
                {aggregatedDailyCollections.length > 0 ? (
                  aggregatedDailyCollections.map((collection) => (
                    <tr key={collection.loan_id}>
                      <td className="py-2 px-4">{collection.loan_id}</td>
                      <td className="py-2 px-4">{collection.tamilname}</td>
                      <td className="py-2 px-4">
                        {collection.totalAmount.toFixed(2)}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="text-center py-4 text-gray-500">
                      No data available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        <div className="p-5 bg-gray-50">
          <h2 className="text-lg font-bold mb-3 text-center">
            Weekly Collection
          </h2>
          <div className="overflow-x-auto">
            <table className="min-w-full bg-white shadow-md rounded-lg overflow-hidden">
              <thead className="bg-gray-100">
                <tr>
                  <th className="py-2 px-4 text-left">Loan Id</th>
                  <th className="py-2 px-4 text-left">Customer Name</th>
                  <th className="py-2 px-4 text-left">Amount</th>
                </tr>
              </thead>
              <tbody>
                {aggregatedWeeklyCollections.length > 0 ? (
                  aggregatedWeeklyCollections.map((collection) => (
                    <tr key={collection.loan_id}>
                      <td className="py-2 px-4">{collection.loan_id}</td>
                      <td className="py-2 px-4">{collection.tamilname}</td>
                      <td className="py-2 px-4">
                        {collection.totalAmount.toFixed(2)}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="text-center py-4 text-gray-500">
                      No data available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TodayCollection;
